
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const goVip = () => {
      console.log(11)

      window.uni.navigateTo({
        url: '/pages/common/payApp/acticityPay/acticityPay',
      })
    }
    return {
      goVip,
    }
  },
})
